import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const Loader = () => (
  <div
    className="flex min-h-screen items-center justify-center bg-vision-ice"
    data-testid="auth-loading"
  >
    <div className="flex items-center gap-3 text-vision-slate/70">
      <span
        className="inline-block h-3 w-3 animate-pulse rounded-full"
        style={{ backgroundColor: "var(--vision-orange)" }}
      />
      Loading…
    </div>
  </div>
);

/**
 * Wraps routes that require an authenticated user.
 * `roles` = array of allowed role strings ("Administrator", "Supervisor", "Assistant Supervisor").
 * When empty, any authenticated user passes.
 */
export const ProtectedRoute = ({ children, roles = [] }) => {
  const { status, user } = useAuth();
  const location = useLocation();

  if (status === "loading") return <Loader />;
  if (status !== "authed" || !user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (roles.length && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default ProtectedRoute;
